<script lang="ts">
  import type { PublicPlayer } from '@banger/shared';
  import Avatar from './Avatar.svelte';

  let { players, big = false, onkick }: {
    players: PublicPlayer[]; big?: boolean; onkick?: (id: string) => void;
  } = $props();
</script>

<ul class:big>
  {#each players as p (p.id)}
    <li class:away={!p.connected}>
      <Avatar emoji={p.emoji} size={big ? 72 : 44} />
      <span class="name">{p.name}</span>
      {#if onkick}
        <button class="kick" aria-label="Remove {p.name}" onclick={() => onkick?.(p.id)}>✕</button>
      {/if}
    </li>
  {/each}
</ul>

<style>
  ul { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 10px; }
  li {
    display: flex; align-items: center; gap: 10px; padding: 6px 8px 6px 6px;
    border-radius: 999px; background: rgba(255, 255, 255, 0.07); min-width: 0;
    animation: pop 0.3s ease-out;
  }
  li.away { opacity: 0.5; }
  .name { font-weight: 700; font-size: 1.05rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 12ch; }
  .big .name { font-size: 2.2rem; max-width: 10ch; }
  .big li { padding-right: 14px; }
  .kick {
    font: inherit; color: #fff; background: rgba(255, 61, 242, 0.25); border: 0; border-radius: 50%;
    width: 36px; height: 36px; min-width: 36px; min-height: 36px; cursor: pointer;
  }
  .kick:hover { background: var(--pink); }
  @keyframes pop { from { transform: scale(0.6); opacity: 0; } to { transform: scale(1); opacity: 1; } }
</style>
